import { Box } from '@mui/material';

interface DayDividerProps {
  label: string;
}

const DayDivider = ({ label }: DayDividerProps) => (
  <Box sx={{ textAlign: 'center', fontSize: '11.5px', color: '#9AA3AD' }}>{label}</Box>
);

export default DayDivider;
